import { render, staticRenderFns } from "./Especialidades.vue?vue&type=template&id=1eaf1a1b&scoped=true&"
import script from "./Especialidades.vue?vue&type=script&lang=js&"
export * from "./Especialidades.vue?vue&type=script&lang=js&"
import style0 from "./Especialidades.vue?vue&type=style&index=0&id=1eaf1a1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eaf1a1b",
  null
  
)

export default component.exports